import { graphql } from '../../gql';

export const POSTING_GET_DATA = graphql(`
  query PostingsData(
    $filters: PostingFilters
    $dim1: Dimension1
    $skip_share_of_postings_scaling: Boolean
  ) {
    posting(
      filters: $filters
      dim1: $dim1
      dim2: date
      skip_share_of_postings_scaling: $skip_share_of_postings_scaling
    ) {
      metadata {
        id
        shortName
        longName
      }
      category {
        metadata {
          id
          shortName
          longName
        }
        metrics {
          salary
          time_to_fill

          active
          new
          removed
          expected_hires
        }
      }
    }
  }
`);

export const POSTING_TOP_ROLES_GET_DATA = graphql(`
  query PostingsRolesData(
    $filters: PostingFilters
    $dim1: Dimension1
    $skip_share_of_postings_scaling: Boolean
  ) {
    posting(
      filters: $filters
      dim1: $dim1
      dim2: top
      skip_share_of_postings_scaling: $skip_share_of_postings_scaling
    ) {
      metadata {
        id
        shortName
        longName
      }
      category {
        metadata {
          id
          shortName
          longName
        }
        metrics {
          count
          share
        }
      }
    }
  }
`);

export const POSTINGS_V3_GET_DATA = graphql(`
  query PostingsV3Data($req: PostingsV3Req!) {
    postings_v3(req: $req) {
      entities {
        index
        short_name
        long_name
        metrics {
          added {
            id
            val
          }
          removed {
            id
            val
          }
          active {
            id
            val
          }
          time_to_fill {
            id
            val
          }
          salary {
            id
            val
          }
          role_counts {
            id
            rank
            short_name
            long_name
            count
            share
          }
          company_counts {
            id
            rank
            short_name
            long_name
            count
            share
          }
        }
      }
    }
  }
`);

export const POSTINGS_V3_TOOLTIP = graphql(`
  query PostingsV3Tooltip($req: PostingsV3Req!) {
    postings_v3(req: $req) {
      entities {
        index
        short_name
        long_name
        metrics {
          active {
            id
            val
          }
          time_to_fill {
            id
            val
          }
        }
      }
    }
  }
`);

export const POSTINGS_GET_ACTIVE = graphql(`
  query PostingsGetActive(
    $filters: PostingFilters
    $dim1: Dimension1
    $skip_share_of_postings_scaling: Boolean
  ) {
    posting(
      filters: $filters
      dim1: $dim1
      dim2: date
      skip_share_of_postings_scaling: $skip_share_of_postings_scaling
    ) {
      metadata {
        id
        shortName
        longName
      }
      category {
        metadata {
          id
          shortName
          longName
        }
        metrics {
          active
        }
      }
    }
  }
`);
